// SocialLinks.js
import React from 'react';
import {
	TWITTER_URL,
	LINKEDIN_URL,
	GITHUB_URL,
	INSTAGRAM_URL,
	FACEBOOK_URL,
} from "../Constant/Constant";
import { Fade } from 'react-awesome-reveal';

const socialLinks = [
  { href: TWITTER_URL, iconClass: 'fab fa-twitter' },
  { href: LINKEDIN_URL, iconClass: 'fab fa-linkedin' },
  { href: GITHUB_URL, iconClass: 'fab fa-github' },
  { href: INSTAGRAM_URL, iconClass: 'fab fa-instagram' },
  { href: FACEBOOK_URL, iconClass: 'fab fa-facebook' },
];
const SocialLinks = () => (
    <Fade direction="up" cascade={true}>
  <nav className="social-links">
    {socialLinks.map((link, index) => (
      <a
        key={index}
        href={link.href}
        target="_blank"
        rel="nofollow noopener noreferrer"
      >
        <i aria-hidden="true" className={link.iconClass}></i>
      </a>
    ))}
  </nav>
    </Fade>
);

export default SocialLinks;
